import { Component, createApp } from 'vue';
import { createPinia } from 'pinia';
import App from 'App.vue';
import { mergeProps } from 'vue';
type Data = Record<string, unknown>;

export class VueApp {
  private static _pinia;

  public static InitVue() {
    this._pinia = createPinia();
  }

  public static Mount(component: Component, target: HTMLElement = null, rootProps?: Data | null) {
    if (!target) {
      target = document.createElement('DIV');
    }

    if ((target as any).__vue_app__) {
      (target as any).__vue_app__.unmount();
    }

    let vueApp = null;

    if ((component as any).emits?.indexOf('unmount') >= 0) {
      vueApp = createApp(
        component,
        mergeProps({ onUnmount: () => VueApp.UnMount(target) }, rootProps)
      );
    } else {
      vueApp = createApp(component, rootProps);
    }

    //vueApp.use(this._pinia);
    let componentInstance = vueApp.mount(target);

    ko.utils.domNodeDisposal.addDisposeCallback(target, () => {
      VueApp.UnMount(target);
    });

    return componentInstance;
  }

  public static UnMount(target: HTMLElement) {
    if ((target as any).__vue_app__) {
      (target as any).__vue_app__.unmount();
    }
  }
}
